export default "__VITE_ASSET__BNTkwHo0__"